import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

class CDNApi {
	static getBaseURL() {
		return localStorage.apiDomain || config.api;
	}

	static getInstance() {
		const instance = axios.create({
			baseURL: this.getBaseURL(),
			headers: {
				'Content-Type': 'application/json'
			}
		});

		instance.interceptors.response.use(
			response => response,
			error => {
				if (!error.response || error.response.status === 401) {
					const event = document.createEvent("Event");
					event.initEvent("SessionExpired", true, true);
					document.dispatchEvent(event);
				}
				return Promise.reject(error);
			}
		);

		return instance;
	}
	static get(path) {
		const cdnInstance = this.getInstance();
		cdnInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return cdnInstance.get(path)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static post(path, payload) {
		const cdnInstance = this.getInstance();
		cdnInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return cdnInstance.post(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static patch(path, payload) {
		const cdnInstance = this.getInstance();
		cdnInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return cdnInstance.patch(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
	static delete(path, payload) {
		const cdnInstance = this.getInstance();
		cdnInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		return cdnInstance.delete(path, payload)
			.then(function (response) {
				return response.data;
			})
			.catch(function (error) {
				throw (error);
			});
	}
}

export default CDNApi;
